import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { BrandContext } from '../../contextProviders/brandContext';
import { useGetFaqContentQuery } from '../../data/kontentAi';
import { FaqsBlock } from '../helpCentre/faqsBlock/faqsBlock';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';

export const FAQContent = ({ faqCategory }) => {
  const { activeBrandContext } = useContext(BrandContext);
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
  const { data: faqsData } = useGetFaqContentQuery({
    brandPartner: activeBrandContext.brand.key,
    faqCodeName: faqCategory,
    previewEnabled: isKontentAiPreviewEnabled
  });

  const hasFaqData = faqsData && Object.keys(faqsData).length > 0;

  return (
    <aside>
      {hasFaqData && (
        <FaqsBlock
          questionSet={faqsData?.FAQs?.questions}
          heading={{ text: 'FAQs' }}
        />
      )}
    </aside>
  );
};

FAQContent.propTypes = {
  faqCategory: PropTypes.string
};
